import { render, staticRenderFns } from "./FreeCourses.vue?vue&type=template&id=3688198a&scoped=true"
import script from "./FreeCourses.js?vue&type=script&lang=js&external"
export * from "./FreeCourses.js?vue&type=script&lang=js&external"
import style0 from "./FreeCourses.scss?vue&type=style&index=0&id=3688198a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688198a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotAccordionToTab: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/AccordionToTab/AccordionToTab.vue').default})
